import React from "react";
import {
Box,
Typography,
Button,
Grid,
Paper,
Link,
} from "@mui/material";
import BookSessionButton from "./BookSessionButton";

const PositivePsychologySession = () => {
return (
    <Box sx={{ py: 2, px: { xs: 2, md: 8 }, bgcolor: "custom.beige" }}>
        {/* On mobile, show image above titles; on desktop, keep image right of text */}
        <Box sx={{ display: { xs: 'block', md: 'none' }, textAlign: 'center', mb: 2 }}>
            <Box
                component="img"
                src="/assets/sara-positive-psychology.jpeg"
                alt="Sara Hafez"
                sx={{
                    width: '100%',
                    maxWidth: 340,
                    borderRadius: 2,
                    boxShadow: 3,
                    mx: 'auto',
                }}
                loading="lazy"
            />
        </Box>
        <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
                        variant="h1"
                        component="h1"
                        // fontWeight={400}
                        color="rgba(47,47,47,1)"
                        gutterBottom
                        sx={{ fontSize: { xs: 28, md: 36 } }}
                    >
                        <strong>Positive Psychology Session</strong>
                    </Typography>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        color="rgba(47,47,47,1)"
                        sx={{ mb: 1, fontSize: { xs: 18, md: 20 } }}
                    >
                        FREE Positive Psychology Session
                    </Typography>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        color="rgba(47,47,47,1)"
                        sx={{ mb: 2, fontSize: { xs: 16, md: 20 } }}
                    >
                        with Sara Hafez, MSc in Positive Psychology (UK)
                    </Typography>
        </Box>
        <Box elevation={3} sx={{  mx: "auto" }}>
            <Grid container spacing={4} alignItems="center">
                {/* On desktop, show image right; on mobile, image is above titles already */}
                <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                    <Typography
                        color="rgba(1,1,1,1)"
                        sx={{ mb: 2, fontSize: { xs: 16, md: 18 } }}
                    >
                        Thank you so much for your interest in connecting with me.
                    </Typography>
                    <Typography
                        fontWeight={700}
                        sx={{ mb: 2, fontSize: { xs: 16, md: 18 } }}
                    >
                        I’m genuinely looking forward to meeting you — to listen, understand where you are right now, and explore what you truly need to move forward with more clarity and calm.
                    </Typography>
                    <Typography
                        sx={{ mb: 2, fontSize: { xs: 16, md: 18 } }}
                    >
                        This is a warm, zero-pressure conversation — simply a space for us to connect and see if working together feels like the right fit.
                        <br />
                        <br />
                        Whether we continue together or not, you’ll leave this session with insight and direction on what you need next to grow, heal, or create the change you’re seeking.
                        <br />
                        <br />
                        <strong>
                            I care deeply about partnering only with clients I can truly support. So if I ever feel I’m not the best person to guide you, I’ll let you know honestly — because what matters most is that you get the help that feels right for you.
                        </strong>
                    </Typography>
                    <BookSessionButton/>
                </Grid>
                <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }} sx={{ textAlign: { xs: "center", md: "right" }, display: { xs: 'none', md: 'block' } }}>
                    <Box
                        component="img"
                        src="/assets/sara-positive-psychology.jpeg"
                        alt="Sara Hafez"
                        sx={{
                            width: { xs: "100%", md: 458 },
                            maxWidth: "100%",
                            borderRadius: 2,
                            boxShadow: 3,
                        }}
                        loading="lazy"
                    />
                </Grid>
            </Grid>
        </Box>
    </Box>
);
};

export default PositivePsychologySession;